import {computed, unref} from "vue";
import {usePcSpaceStore} from "@/store/pcSpaceStore";
import {storeToRefs} from "pinia";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {usePageModelsStore} from "@/store/modules/pageModels";

/**
 * 监听子变量变化
 * @param pageModelsStore
 * @param value
 * @param subPropId
 * @param itemObj
 * @param dataSourceStore
 */
const watchStateSubProp=function ({pageModelsStore,value,subPropId,itemObj,dataSourceStore}){
  watch(() => pageModelsStore.state[value]&&pageModelsStore.state[value][subPropId], (newVal) => {
    if(pageModelsStore.timerOutList&&pageModelsStore.timerOutList[itemObj.id+value]){
      clearTimeout(pageModelsStore.timerOutList[itemObj.id+value])
    }
    if(pageModelsStore.state[value]==null){
      return
    }
    if(pageModelsStore.state[value][subPropId]==null){
      return;
    }
    if(pageModelsStore.timerOutList==null){
      pageModelsStore.timerOutList={};
    }
    pageModelsStore.timerOutList[itemObj.id+value]=setTimeout(()=>{
      //清空缓存
      dataSourceStore.removeCacheByCode(itemObj.queryCode);
      //重新查询
      dataSourceStore.getDatasByQueryCode(itemObj.queryCode,pageModelsStore);
    },10)
  })
}
/**
 * 监听state变量变化
 * @param pageModelsStore
 * @param value
 * @param itemObj
 * @param dataSourceStore
 */
const watchStateProp=function ({pageModelsStore,value,itemObj,dataSourceStore}){
  watch(() => pageModelsStore.state[value], (newVal) => {
    if(pageModelsStore.timerOutList&&pageModelsStore.timerOutList[itemObj.id+value]){
      clearTimeout(pageModelsStore.timerOutList[value])
    }
    if(pageModelsStore.timerOutList==null){
      pageModelsStore.timerOutList={};
    }
    pageModelsStore.timerOutList[itemObj.id+value]=setTimeout(()=>{
      dataSourceStore.removeCacheByCode(itemObj.queryCode);
      dataSourceStore.getDatasByQueryCode(itemObj.queryCode,pageModelsStore);
    },10)
  }, {immediate: true})
}

/**
 * 注册查询监听
 * @param dsAry
 * @param pageModelsStore
 */
export const initWatch = (dsAry, pageModelsStore,dataSourceStore) => {
  if (dsAry && Array.isArray(dsAry)) {
    dsAry.filter((itemDb) => {
      return itemDb.watchList && itemDb.watchList.length > 0
    }).forEach((itemObj) => {
      try{
        itemObj.watchList.forEach((waItem) => {
          const {value, subPropId} = waItem;
          if (value&&subPropId) {
            watchStateSubProp({pageModelsStore,value,subPropId,itemObj,dataSourceStore});
          } else {
            watchStateProp({pageModelsStore,value,itemObj,dataSourceStore});
          }
        })
      }catch (e){
        console.error(e,"========")
      }
    })
  }
}

export function changeDbObjToSpaceObj(firstSpaceObj,dataSourceStore) {
  //栏目信息
  if (firstSpaceObj.sectionConfigs&&typeof(firstSpaceObj["sectionConfigs"])==='string') {
    try {
      firstSpaceObj["sectionConfigs"] = JSON.parse(firstSpaceObj["sectionConfigs"]);
      if (firstSpaceObj["sectionConfigs"]) {
        firstSpaceObj = {...firstSpaceObj, ...firstSpaceObj["sectionConfigs"]};
      }
    } catch (e) {
      console.error(e, "======")
    }
  }
  //数据源
  if (firstSpaceObj.dataSourceConfig&&typeof(firstSpaceObj["dataSourceConfig"])==='string') {
    try {
      firstSpaceObj["dataSourceConfig"] = JSON.parse(firstSpaceObj["dataSourceConfig"]);
    } catch (e) {
      console.error(e, "======")
    }
  }
  //栏目边框信息
  if (firstSpaceObj.borderModuleConfig&&typeof(firstSpaceObj["borderModuleConfig"])==='string') {
    try {
      firstSpaceObj["rows"] = JSON.parse(firstSpaceObj["borderModuleConfig"]);
      delete firstSpaceObj["borderModuleConfig"];
    } catch (e) {
      console.error(e, "======")
    }
  }
  return firstSpaceObj;
}


/**
 * 设置用户空间的hook
 */
export function useSpaceHook() {
  const pcSpaceStore = usePcSpaceStore();
  const pageModelsStore = usePageModelsStore();
  const {appCurSpaceItem}=storeToRefs(pcSpaceStore);
  const dataSourceStore = useDataSourceStore();



  const loadingFlag=computed(()=>{
    return pcSpaceStore.loadingFlag;
  });

  const setItemToCurSpace=function (firstSpaceObj){
    firstSpaceObj=changeDbObjToSpaceObj(firstSpaceObj,dataSourceStore);
    //存入store
    pcSpaceStore.setPcSpaceObj(firstSpaceObj);
    dataSourceStore.setDataSourceList(firstSpaceObj.dataSourceConfig,pageModelsStore);
    pcSpaceStore.setCurSpaceItem(firstSpaceObj);
    nextTick(()=>{
      pcSpaceStore.setLoadingFlag(false);
      initWatch(firstSpaceObj["dataSourceConfig"], pageModelsStore,dataSourceStore);
    })
  }

  const setAppItemToCurSpace=function (firstSpaceObj){
    pcSpaceStore.setLoadingFlag(true);
    firstSpaceObj=changeDbObjToSpaceObj(firstSpaceObj,dataSourceStore);
    //存入store
    pcSpaceStore.setPcSpaceObj(firstSpaceObj);
    dataSourceStore.setDataSourceList(firstSpaceObj.dataSourceConfig,pageModelsStore);
    pcSpaceStore.setCurAppSpaceItem(firstSpaceObj);
    nextTick(()=>{
      pcSpaceStore.setLoadingFlag(false);
      initWatch(firstSpaceObj["dataSourceConfig"], pageModelsStore,dataSourceStore);
    })
  }
  //设置子应用的空间
  const selAppSpaceItem=function (firstSpaceObj:any){
    setAppItemToCurSpace(firstSpaceObj);
  }
  //设置当前空间
  const selSpaceItem=function (firstSpaceObj:any){
    setItemToCurSpace(firstSpaceObj);
  }

  //获取当前的布局
  const getCurSpaceItem = computed(() => pcSpaceStore.curSpaceItem);
  if(unref(getCurSpaceItem)){
    setItemToCurSpace(unref(getCurSpaceItem));
  }
  //获取空间列表
  const getPcSpaceList = computed(() => pcSpaceStore.pcSpaceList);
  //获取当前子应用的 配置信息
  const getAppCurSpaceItem=computed(() => pcSpaceStore.appCurSpaceItem);
  //获取进入的当前子应用
  const getAppSpaceList = computed(() => pcSpaceStore.appSpaceList);

  /**
   * 主应用空间的动态样式
   */
  const panelSty=computed(()=>{
    if(unref(getPcSpaceList).length===1){
      return {width:'auto'}
    }
    if(unref(getPcSpaceList).length===2){
      return {width:'198px'}
    }
    if(unref(getPcSpaceList).length>=3){
      return {width:'300px'}
    }
  })

  /**
   * 子应用空间的动态样式
   */
  const appPanelSty=computed(()=>{
    if(unref(getAppSpaceList).length===1){
      return {width:'auto'}
    }
    if(unref(getAppSpaceList).length===2){
      return {width:'198px'}
    }
    if(unref(getAppSpaceList).length>=3){
      return {width:'300px'}
    }
  })

  const clearCurSpaceItem=function (){
    appCurSpaceItem.value=null
  }

  return {
    loadingFlag,
    appPanelSty,
    clearCurSpaceItem,
    panelSty,
    getAppCurSpaceItem,
    getAppSpaceList,
    selAppSpaceItem,
    selSpaceItem,
    getPcSpaceList,
    getCurSpaceItem
  }
}
